import { useMemo } from 'react'
import { useDebounce } from '../../../../../../_metronic/helpers'
import { useListFilters } from './ListFiltersProvider'
import { useQueryResponse } from './QueryResponseProvider'
import { ColaboradorList } from './_models'

/** Coordenadores do empregador, filtrados no client pela busca (nome, conselho ou RQE). */
export const useCoordenadoresFiltrados = (): ColaboradorList[] => {
  const { responseSemPaginacao: cliente } = useQueryResponse()
  const { filters } = useListFilters()
  const busca = useDebounce(filters.busca, 300).trim().toLowerCase()

  return useMemo(() => {
    const todos = cliente?.colaboradores ?? []
    if (!busca) return todos
    return todos.filter((c) =>
      [c.nome, c.crm, c.rqe].some((campo) => campo?.toLowerCase().includes(busca))
    )
  }, [cliente?.colaboradores, busca])
}
